import { InfoCircle } from 'iconsax-react';
import PropTypes from 'prop-types';
import success from '../../assets/images/success.svg';
import Text from '../../assets/styles/Text';
import * as styles from './styles';

export default function GroupCheck({ children, check, error = null }) {
  return (
    <styles.Container className="checked-div">
      <div>
        <styles.Boll $check={check}>
          <img src={success} alt="Sucesso" />
        </styles.Boll>
        {children}
      </div>
      {error && (
        <styles.Error>
          <InfoCircle />
          <Text.Span>{error}</Text.Span>
        </styles.Error>
      )}
    </styles.Container>
  );
}

GroupCheck.propTypes = {
  children: PropTypes.node.isRequired,
  check: PropTypes.bool.isRequired,
  error: PropTypes.string,
};
